<template>
  <h3>
    茅屋为秋风所破歌
    <el-button type="primary">杜甫</el-button>
  </h3>
</template>
<script>
export default {
  name: 'test'
}
</script>